import { render, staticRenderFns } from "./FormDelivery.vue?vue&type=template&id=39bfbf24"
import script from "./FormDelivery.vue?vue&type=script&lang=js"
export * from "./FormDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormDelivery.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bfbf24')) {
      api.createRecord('39bfbf24', component.options)
    } else {
      api.reload('39bfbf24', component.options)
    }
    module.hot.accept("./FormDelivery.vue?vue&type=template&id=39bfbf24", function () {
      api.rerender('39bfbf24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormDelivery.vue"
export default component.exports